import { getStrPersisted } from '@/types/LocalStorage';

export function getLocale () {
    const locale = getStrPersisted('locale') || 'en-gb'
    return locale
}
